<footer class="footer mt-5">
    <div class="container p-4">
        <img src="./assets/img/logo-duoc-2.svg" alt="">
    </div>
</footer>